import { Routes } from '@angular/router';
import {L1AuthGuard} from "./guards/l1-auth.guard";
import {L3AuthGuard} from "./guards/l3-auth-guard";

export const routes: Routes = [
  {
    path: 'oauth',
    loadComponent: () =>
      import('./auth/oauth/oauth.component')
        .then(m => m.OauthComponent),
        
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.routes')
      .then(m => m.PagesRoutes),
    canActivate: [L1AuthGuard, L3AuthGuard],
    data: {
      breadcrumb: 'HOME'
    },
  },
  {path: '', redirectTo: 'pages', pathMatch: 'full'},
  {path: '**', redirectTo: 'pages'},

];
